import { Box, Typography } from "@mui/material";
import { usePermissions } from "react-admin";
import { hasPermission } from "@/utils/permissions";
import { getResourceIcon } from "@/utils/icons";
import { ResourceName } from "@/types";
import { EnvironmentBadge } from "./EnvironmentBadge";
import { getActivePartnerName } from "../partner/PartnerSwitcherMenuItem";

const PartnerIcon = getResourceIcon(ResourceName.PARTNERS);

/**
 * Displays the active partner name and environment badge in the breadcrumb bar.
 * Only visible for users with partner-delegation:use permission (SuperAdmin / delegated users).
 */
export const PartnerContextBar = () => {
  const { permissions, isLoading } = usePermissions();

  if (isLoading) return null;

  const canSwitch = hasPermission(permissions, "partner-delegation", "use");
  if (!canSwitch) return null;

  const partnerName = getActivePartnerName();

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      {partnerName && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <PartnerIcon sx={{ fontSize: 16, color: "text.secondary" }} />
          <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>
            {partnerName}
          </Typography>
        </Box>
      )}
      <EnvironmentBadge />
    </Box>
  );
};
